import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { VbPaymentChangeRecurringPaymentFormGroup } from '../../../../../models/shared/forms/vb-payment-change-recurring-payment-form-group';
import * as moment from 'moment';
import { DateUtils } from '../../../../../utils/date-utils';

const DATE_ERRORS = ['paymentStartPastDate', 'paymentStartCutoffPassed'] as const;

function clearDateErrors(control: AbstractControl): void {
  if (!control.errors) return;
  const errors = { ...control.errors };
  let changed = false;
  for (const key of DATE_ERRORS) {
    if (errors[key]) {
      delete errors[key];
      changed = true;
    }
  }
  if (changed) {
    control.setErrors(Object.keys(errors).length ? errors : null);
  }
}

export function recurringPaymentStartDateValidator(allowableChangeDateIsoString: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const group = formGroup as VbPaymentChangeRecurringPaymentFormGroup;
    const monthControl = group.controls.paymentStartMonth;
    const yearControl = group.controls.paymentStartYear;

    const month = monthControl.value;
    const year = yearControl.value;

    // If either value is missing, skip validation
    if (month === null || year === null) {
      clearDateErrors(monthControl);
      return null;
    }

    // Construct moment from month/year (1st day of the month)
    const constructedDate = moment({ year, month: month - 1, day: 1 });
    const allowableChangeDate = moment(allowableChangeDateIsoString);

    if (constructedDate.isBefore(allowableChangeDate, 'day')) {
      const isBeforeCurrentMonth = constructedDate.isBefore(moment(DateUtils.todayInCST()), 'month');

      if (isBeforeCurrentMonth) {
        // Selected date is fully in the past
        clearDateErrors(monthControl);
        monthControl.setErrors({ ...monthControl.errors, paymentStartPastDate: true });
        return { paymentStartPastDate: true };
      } else {
        // Selected date is next month but cutoff has passed
        clearDateErrors(monthControl);
        monthControl.setErrors({ ...monthControl.errors, paymentStartCutoffPassed: true });
        return { paymentStartCutoffPassed: true };
      }
    } else {
      clearDateErrors(monthControl);
      return null;
    }
  };
}
